import axios from "axios";
import apiConfig from "../config/apiConfig";

const contactApiInstance = axios.create({
  baseURL: apiConfig.endpoints.contactService.baseURL,
  timeout: 15000,
});

const contact = async (body) => {
  try {
    const response = await contactApiInstance.post(apiConfig.endpoints.contactService.routes.contactForm, body);
    return response.data ? response.data : response;
  } catch (error) {
    return error.data ? error.data : error;
  }
};
const subscribe = async (type, body) => {
  try {
    const routeMap = {
      newsletter: apiConfig.endpoints.contactService.routes.newsletterSubscribe,
      jobs: apiConfig.endpoints.contactService.routes.jobsSubscribe,
      business: apiConfig.endpoints.contactService.routes.businessSubscribe,
    };

    const route = routeMap[type];
    if (!route) throw new Error("Invalid subscription type");

    const response = await contactApiInstance.post(route, body);
    return response.data ?? response;
  } catch (error) {
    return error.response?.data ?? error;
  }
};

const JobsRequest = async (body) => {
  try {
    const response = await contactApiInstance.post(apiConfig.endpoints.contactService.routes.JobsRequest, body);
    return response.data ? response.data : response;
  } catch (error) {
    return error.data ? error.data : error;
  }
};

const BusinessRequest = async (body) => {
  try {
    const response = await contactApiInstance.post(apiConfig.endpoints.contactService.routes.BusinessRequest, body);
    return response.data ? response.data : response;
  } catch (error) {
    return error.data ? error.data : error;
  }
};


const contactApi = {
  contact,
  subscribe,
  JobsRequest,
  BusinessRequest,
};

export default contactApi;